// extracted by mini-css-extract-plugin
export default {"container":"Zr-z","ratingLayout":"_r-z","ratingLabel":"as-z","nonInteractiveRatingLabel":"bs-z"};